//React
import { useState, useEffect, useRef } from "react";

//Chakra
import {
  SimpleGrid,
  VStack,
  Box,
  Text,
  Flex,
  Button,
  Center,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Heading,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useToast,
} from "@chakra-ui/react";

//Custom Component
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody.js";

//Endpoint
import CardBadge from "components/Card/CardBadge.js";
import moment from "moment";
import { useFormik } from "formik";
import { updateReportStatus } from "service/report.service";

//Package
const { useLocation, useHistory } = require("react-router-dom/cjs/react-router-dom.min");

export default function reportDetail() {
  // variable
  const location = useLocation();
  const history = useHistory();
  const toast = useToast();

  const [report, setReport] = useState(location?.state ?? null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef(null);

  //form
  const formik = useFormik({
    initialValues: {
      report_id: report.id,
      publish: {
        to_unpublish: false,
      },
      report: {
        is_resolved: report?.is_resolved ? true : false,
      },
    },

    onSubmit: async (values) => {
      try {
        const report = await updateReportStatus(values.report_id, values);

        if (report)
          toast({
            title: "Update Success",
            description: "Report status has been updated.",
            status: "success",
            duration: 9000,
            isClosable: true,
            position: "bottom-left",
          });

        history.push("/admin/report");
      } catch (error) {
        console.log(error);

        toast({
          title: "Update Failed",
          description: "Report status failed to update.",
          status: "error",
          duration: 9000,
          isClosable: true,
          position: "bottom-left",
        });
      }
    },
  });

  //setup
  // useEffect(() => {}, []);

  //component
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <>
        <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
          <CardHeader p="6px 0px 22px 0px">
            <Text
              fontSize="lg"
              color="#fff"
              fontWeight="bold"
              textColor={"cyan.300"}
              textTransform={"uppercase"}
            >
              Report
            </Text>
          </CardHeader>
          <CardBody w={"full"}>
            <SimpleGrid columns={2} w={"full"}>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Date Created</Text>
                <CardBadge
                  props={
                    report?.created_at
                      ? moment(report?.created_at).format("YYYY-MM-DD")
                      : ""
                  }
                />
              </VStack>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Type</Text>
                <CardBadge props={report?.report_type?.name} />
              </VStack>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>User Name</Text>
                <CardBadge props={report?.user?.username} />
              </VStack>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Message</Text>
                <CardBadge props={report?.message} />
              </VStack>
            </SimpleGrid>
          </CardBody>
        </Card>
        <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
          <CardHeader p="6px 0px 22px 0px">
            <Text
              fontSize="lg"
              color="#fff"
              fontWeight="bold"
              textColor={"limegreen"}
              textTransform={"uppercase"}
            >
              Resource
            </Text>
          </CardHeader>
          {report?.reportable_type == "order" && <ReportOrderCard />}
          {report?.reportable_type != "order" && <ReportResourceCard />}
        </Card>

        <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
          <CardHeader p="6px 0px 22px 0px">
            <Text
              fontSize="lg"
              color="#fff"
              fontWeight="bold"
              textColor={"beige"}
              textTransform={"uppercase"}
            >
              Stats
            </Text>
          </CardHeader>
          <CardBody w={"full"}>
            <SimpleGrid columns={2} w={"full"}>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Report No. / Total Report</Text>
                <Flex>
                  <CardBadge props={report?.reportable_no} />
                  <Text textColor={"white"} mx={"3"}>
                    /
                  </Text>{" "}
                  <CardBadge props={report?.total_reports} />
                </Flex>
              </VStack>
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Report Status </Text>
                {report?.is_resolved ? (
                  <Text textColor={"green.400"}>Closed</Text>
                ) : (
                  <Text textColor={"yellow.400"}>Open</Text>
                )}
              </VStack>
            </SimpleGrid>
          </CardBody>
        </Card>
        <Heading textColor={"white"} mt={"8"} pl={"2"}>
          Action
        </Heading>
        <Flex
          direction={"column"}
          textColor={"white"}
          fontWeight={"extrabold"}
          p={"2"}
          rounded={"md"}
          textAlign={"left"}
          alignContent={"flex-start"}
        >
          <RadioGroup>
            <Flex direction={"column"}>
              <Checkbox
                defaultChecked={formik.values.report.is_resolved}
                p={2}
                value={1}
                size={"lg"}
                onChange={(e) => {
                  formik.setFieldValue("report.is_resolved", e.target.checked);
                }}
              >
                <Flex>
                  <Text fontSize={"2xl"} mx={"2"}>
                    Report to be:
                  </Text>
                  {formik.values.report.is_resolved ? (
                    <Text textColor={"green.500"} fontSize={"2xl"}>
                      Closed
                    </Text>
                  ) : (
                    <Text textColor={"yellow.500"} fontSize={"2xl"}>
                      Open
                    </Text>
                  )}
                </Flex>
              </Checkbox>
              <Checkbox
                // defaultChecked={(e) => {
                //   if (!formik.values.publish.to_unpublish) {
                //     formik.setFieldValue("publish.to_unpublish", false);
                //     return false;
                //   } else {
                //     formik.setFieldValue("publish.to_unpublish", true);
                //     return true;
                //   }
                // }}
                defaultChecked={formik.values.publish.to_unpublish}
                fontSize={"4xl"}
                p={2}
                value={1}
                size={"lg"}
                onChange={(e) => {
                  // console.log(
                  //   "publish.to_unpublish formik before",
                  //   formik.values.publish.to_unpublish
                  // );
                  formik.setFieldValue("publish.to_unpublish", e.target.checked);

                  // console.log("publish.to_unpublish checked", e.target.checked);
                }}
              >
                <Flex>
                  <Text fontSize={"2xl"} mx={"2"}>
                    Resource to be:
                  </Text>
                  {formik.values.publish.to_unpublish ? (
                    <Text textColor={"red.500"} fontSize={"2xl"}>
                      Unpublished
                    </Text>
                  ) : (
                    <Text textColor={"green.500"} fontSize={"2xl"}>
                      Published
                    </Text>
                  )}
                </Flex>
              </Checkbox>
            </Flex>
          </RadioGroup>
        </Flex>
        <Center>
          <Button
            my={"6"}
            mx={"5"}
            textColor={"black"}
            w={"sm"}
            onClick={() => {
              onOpen();
            }}
          >
            Update Ticket
          </Button>
        </Center>
      </>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Update Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              <Flex direction={"column"}>
                <Text
                  fontSize={"lg"}
                  fontWeight={"bold"}
                  bgColor={"gray.200"}
                  rounded={"md"}
                  p={"2"}
                  textColor={"red.400"}
                  textTransform={"uppercase"}
                >
                  Close Report
                </Text>
                <Text>This will mark this ticket as closed/resolved.</Text>
              </Flex>
            </AlertDialogBody>

            <AlertDialogBody>
              <Flex direction={"column"}>
                <Text
                  fontSize={"lg"}
                  fontWeight={"bold"}
                  bgColor={"gray.200"}
                  rounded={"md"}
                  p={"2"}
                  textColor={"red.400"}
                  textTransform={"uppercase"}
                >
                  Unpublish Resource
                </Text>
                <Text>This will hide the listing of the resource from public view</Text>
              </Flex>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="green"
                onClick={() => {
                  formik.submitForm();
                  onClose();
                }}
                ml={3}
              >
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );

  function ReportOrderCard() {
    return (
      <CardBody w={"full"}>
        <SimpleGrid columns={2} w={"full"}>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Type</Text>
            <CardBadge props={report?.reportable_type} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Order No</Text>
            <CardBadge props={report?.reportable?.order_no} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Order Status</Text>
            <CardBadge props={report?.reportable?.order_status?.order_status} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Delivery Status</Text>
            <CardBadge props={report?.reportable?.order_status?.delivery_status} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Orderable Title</Text>
            <CardBadge props={report?.reportable?.order_detail?.title} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Orderable Description</Text>
            <CardBadge props={report?.reportable?.order_detail?.description} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Hirer (Username)</Text>
            <CardBadge props={report?.reportable?.user?.username} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Gigger (Username)</Text>
            <CardBadge props={report?.reportable?.professional_profile?.user?.username} />
          </VStack>
        </SimpleGrid>
      </CardBody>
    );
  }

  function ReportResourceCard() {
    return (
      <CardBody w={"full"}>
        <SimpleGrid columns={2} w={"full"}>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Type</Text>
            <CardBadge props={report?.reportable_type} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Owner (Username)</Text>
            <CardBadge
              props={
                report?.reportable_type == "job"
                  ? report?.reportable?.user?.username
                  : report?.reportable?.professionalProfile?.user?.username
              }
            />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Title</Text>
            <CardBadge
              props={
                report?.reportable_type == "job"
                  ? report?.reportable?.title
                  : report?.reportable?.name
              }
            />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Description</Text>
            <CardBadge props={report?.reportable?.description} />
          </VStack>
          <VStack alignItems={"start"} my={"3"}>
            <Text color={"white"}>Status</Text>
            {/* <CardBadge props={report?.reportable?.is_active} /> */}
            {report?.reportable?.is_active == 0 ? (
              <Text textColor={"red.400"} fontWeight={"extrabold"} fontSize={"lg"}>
                INACTIVE
              </Text>
            ) : (
              <Text textColor={"green.400"} fontWeight={"extrabold"} fontSize={"lg"}>
                ACTIVE
              </Text>
            )}
          </VStack>
        </SimpleGrid>
      </CardBody>
    );
  }
}
